import { AnyAction, Dispatch, createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'Utils/store'
import { multiSelectSlice } from 'Slices/multiSelectSlice'
import TCPAConsentConfig from 'Configs/fields/tcpa_consent.json'
import { ContractSource } from 'Types/contractTypes'

const contractSource = ContractSource.candidates

const transformValues = function (selectedValues) {
  return selectedValues.map((value) => (value === 'None Selected' ? '' : value))
}

export const TCPAConsentSlice = multiSelectSlice(
  TCPAConsentConfig.column,
  'setTCPAConsent',
  TCPAConsentConfig.data,
  TCPAConsentConfig.meta,
  transformValues
)

export const selectTCPAConsent = createSelector(
  ({ onDemandFilter: { prospectProfile } }: RootState) =>
    prospectProfile.TCPAConsent.selectedValues,
  (
    selectedValues: string[]
  ): {
    selectedValues: string[]
    values: string[]
    audienceTypes: string[]
    label
  } => {
    return {
      selectedValues,
      values: TCPAConsentConfig.data,
      audienceTypes: TCPAConsentConfig.source[contractSource].audience_types,
      label: TCPAConsentConfig.meta.label,
    }
  }
)

export const { setTCPAConsent } = TCPAConsentSlice.actions

export default TCPAConsentSlice.reducer
